import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const createCompanyCustomer = (params) => {
  return Api(endPoints.companyCustomerCreate, params, requestType.POST);
};

const getAllCompanyCustomers = (id) => {
  return Api(
    `${endPoints.companyCustomersGet}?createdBy=${id}`,
    null,
    requestType.GET
  );
};

const updateCompanyCustomerStatus = (id, params) => {
  return Api(
    `${endPoints.companyCustomersStatusUpdate}/${id}`,
    params,
    requestType.PUT
  );
};

const updateCompanyCustomer = (creatorId, id, params) => {
  return Api(
    `${endPoints.companyCustomerUpdate}/${creatorId}/${id}`,
    params,
    requestType.PUT
  );
};

export {
  createCompanyCustomer,
  getAllCompanyCustomers,
  updateCompanyCustomer,
  updateCompanyCustomerStatus,
};
